import script from "./delayedReview.vue?vue&type=script&setup=true&lang=js"
export * from "./delayedReview.vue?vue&type=script&setup=true&lang=js"

import "./delayedReview.vue?vue&type=style&index=0&id=0d21cc51&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d21cc51"]])

export default __exports__